import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Nav, NavItem, Badge, Collapse, Button, Panel, ButtonToolbar} from 'react-bootstrap';
import FeedbackChain from "./models/FeedbackChain";
import {withRouter} from 'react-router-dom';


@withRouter @injectIntl @inject('rootStore','feedbackChainsStore', 'authorizationsStore') @observer
export default class ViewsMenu extends React.Component{

    render() {
        const availableViews = Object.values(FeedbackChain.viewFilters);
        const {intl, feedbackChainsStore} = this.props;
        const activeStatistics = this.props.location.pathname.match(/analytics/) != undefined;
        return (
            <div>
                {!activeStatistics && 
                    <Panel>
                        <h4><i className='fa fa-server'/>&nbsp; {intl.formatMessage({id: 'views_title'})}</h4>
                        <Collapse in={!activeStatistics}>
                            <Nav bsStyle="pills" stacked activeKey={feedbackChainsStore.filter} onSelect={this.handleSelect}>
                                { availableViews.map( (view, idx) =>
                                    <NavItem key={idx} eventKey={view}>
                                        <div className='relative-position'>
                                            <div className={'pill-text'} style={{marginRight: '20px',}}>{intl.formatMessage({id: view + "_view_title"})}</div>
                                            <Badge className={"pull-right top-right"}>{this.props.feedbackChainsStore.feedbacksByFilter(view).length}</Badge>
                                        </div>
                                    </NavItem>
                                )}
                            </Nav>
                        </Collapse>
                    </Panel>
                }
                <ButtonToolbar>
                    {activeStatistics &&     
                        <Button 
                            style={{padding: '10px'}}
                            active={!activeStatistics} bsStyle={ !activeStatistics ? 'primary':'default'} 
                            block
                            onClick={this.handleViewsButtonClick}
                        >
                            <i className='fa fa-server'/>&nbsp;
                            {intl.formatMessage({id: 'views_link'})}
                        </Button>
                    }

                    { this.props.authorizationsStore.canSeeAnalytics() &&    <Button 
                            style={{padding: '10px'}}
                            active={activeStatistics} 
                            bsStyle={ activeStatistics ? 'primary':'default'} 
                            block
                            onClick={this.handleStatisticsButtonClick}
                        >
                            <i className='fa fa-bar-chart' />&nbsp;{intl.formatMessage({id: 'statistics_link'})}
                        </Button>
                    }

                </ButtonToolbar>
                <br/>
            </div>
        );
    }

    handleViewsButtonClick = () =>{
        const {rootStore} = this.props;
        if( this.activeStatistics() ){
            this.props.history.push("/"+rootStore.localeStore.locale+"/gstartup/"+rootStore.startupId+"/igsupport");
        }
    }

    handleStatisticsButtonClick = () =>{
        const {rootStore} = this.props;
        if( !this.activeStatistics()){
            this.props.history.push("/"+rootStore.localeStore.locale+"/gstartup/"+rootStore.startupId+"/igsupport/analytics");
        }
    }

    activeStatistics(){
        return this.props.location.pathname.match(/analytics/);
    }

    handleSelect = (k) => {
        this.props.feedbackChainsStore.filterByView(k);
    }
}